import { render } from "./deletedClients.vue?vue&type=template&id=4170501c"
import script from "./deletedClients.vue?vue&type=script&lang=js"
export * from "./deletedClients.vue?vue&type=script&lang=js"

import "./deletedClients.vue?vue&type=style&index=0&id=4170501c&lang=css"

import exportComponent from "C:\\Users\\Luis\\Documents\\Anfisbena\\Projects\\crm\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__